import { Component, ViewChild, Input } from '@angular/core';
import ArrayStore from 'devextreme/data/array_store';
import { __i18n, LocalisationService } from '@localisation';
import { ParameterWindowComponent } from './parameter-window.component';

@Component({
    selector: 'mapping-window',
    templateUrl: './mapping-window.template.html',
    standalone: false
})
export class MappingWindowComponent extends ParameterWindowComponent {
    constructor(
        public localisation: LocalisationService
    ){
        super(localisation)
    }

    @ViewChild('slider', { static : false})
    public slider: any;

    @ViewChild('plantGrid', { static : false})
    public plantGrid: any;

    @ViewChild('applicationSetGrid', { static : false})
    public applicationSetGrid: any;


    @Input()
    public set data(data: any){
        if(JSON.stringify(data) === JSON.stringify(this.innerData)){
            return;
        }
        this.innerData = data;
        this.plantData =  new ArrayStore({
            key: 'SiteFileId',
            data: (data?.objectHandlerMappingFileNames?.length)
                ? data.objectHandlerMappingFileNames :  []
        });

        this.applicationData = new ArrayStore({
            key: 'id',
            data: (data.applicationSetObjectHandlerMappingFile) ? [data.applicationSetObjectHandlerMappingFile] : null
        });
        this.selectRows();
    }

    public get data(){
        return this.innerData;
    }

    public selectRows(){
        if(this.addCurrentEntry){
            this.selector.selectEntry(__i18n('<use application set>', 'upgrade.use-application-set.text'));
            this.selectedEntry = null;
        }
    }

    public ngAfterViewInit(){

        setTimeout(() => {
            this.grids.push({
                name : 'plant',
                instance : this.plantGrid.dxDataGrid.instance,
                grid : this.plantGrid
            });
            this.grids.push({
                name : 'application-set',
                instance : this.applicationSetGrid.dxDataGrid.instance,
                grid : this.applicationSetGrid
            });
            this.selectRows();
            this.selector.onOpen.subscribe(() => {
                setTimeout(() => this.slideToSelected(), 100);
            });
        });
    }
}
